import { MouseEvent } from 'react';
import { Baby } from '@snapi/types';
import { DateUtils } from '@snapi/utils';
import { TextButton } from '@snapi/luxury';
import { differenceInDays } from 'date-fns';

const asAge = (dob: string) => {
  const ageInMontsh = DateUtils.ageInMonths(dob);

  if (ageInMontsh <= 0) {
    const days = differenceInDays(Date.now(), new Date(dob));
    if (days <= 0) {
      return 'waiting';
    } else {
      return `${days} days`;
    }
  } else if (ageInMontsh === 1) {
    return '1 month';
  } else {
    return `${ageInMontsh} months`;
  }
};

export interface BabyCardProps {
  baby: Pick<Baby, 'name' | 'dob'>;
  onEdit?(): void;
}

export const BabyCard: React.FC<BabyCardProps> = ({
  baby: { name, dob },
  onEdit,
}) => {
  const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onEdit?.();
  };

  return (
    <div className="relative flex flex-1 justify-center items-center gap-3 px-2.5 py-3 rounded-[10px]">
      <div className="flex justify-center items-center text-white h-[60px] w-[60px] rounded-full bg-purple">
        <h3 className="uppercase">{name.substring(0, 1)}</h3>
      </div>
      <div className="flex flex-1 gap-1 flex-col sm:flex-row sm:gap-2">
        <h5 className="flex sm:self-center">
          {name}, {asAge(dob)}
        </h5>
        {onEdit && (
          <div className="flex">
            <TextButton onClick={handleEdit} secondary>
              (info)
            </TextButton>
          </div>
        )}
      </div>
    </div>
  );
};
